"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachPlatform = function SvgBeachPlatform(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 34",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.653 25.228c3.458.556 5.62.027 6.486-1.588 2.353 1.762 7.35 2.16 9.074 0 2.044 1.605 6.862 2.291 9.27 0 2.738 1.666 6.777 2.096 8.682-.177 1.696 1.565 5.11 1.765 7.438 1.765m-40.95 4.005c3.458.556 5.62.026 6.486-1.589 2.353 1.763 7.35 2.161 9.074 0 2.044 1.606 6.862 2.292 9.27 0 2.738 1.667 6.777 2.096 8.682-.177 1.696 1.565 5.11 1.766 7.438 1.766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.606 25.329 13.78 5.296h31.914l2.544 20.033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.06 9.912v-2.2h11.324v2.2M24.06 13.916v-2.199h11.324v2.2M24.06 17.92v-2.199h11.324v2.2M24.06 21.925v-2.2h11.324v2.2"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgBeachPlatform);
var _default = Memo;
exports["default"] = _default;